/* bacter-hospitales.js
   Calculadora de dosis para sector salud (BACTER spp.)

   Segmentos (rangos típicos en carga baja):
   - Centro pequeño  → alrededor de 600 g/mes
   - Centro mediano  → alrededor de 900 g/mes
   - Centro grande   → a partir de 1500 g/mes

   Escenario base de referencia (centro pequeño):
   - Carga orgánica baja, modo mantenimiento.
   - Valores de puntos se usan solo para escalar la dosis.
   - Los servicios opcionales (cocina, lavandería, laboratorios, etc.)
     empiezan siempre en 0: solo suman si el usuario los activa y llena.

  // Regla de solución madre:
  // - Aproximadamente 1 L de solución madre por cada 80 g de producto.
  // - litrosSolAplic = gPorAplicacion / 80.
  // - El total de litros se reparte entre zonas según los gramos asignados.
  //   De esta forma la aplicación es más concentrada y se usa menos agua por punto.

*/

(function () {
  'use strict';

  // -------------------------
  //  CONSTANTES
  // -------------------------

  var SEGMENTO_MIN_G = {
    pequeno: 600,
    mediano: 900,
    grande: 1500
  };

  // referencia base (centro pequeño, carga baja)
  var BASE_G_PEQUENO = SEGMENTO_MIN_G.pequeno;

  var BASE_CAUDAL_L_DIA = 15000;
  var BASE_DBO = 400;
  var BASE_DQO = 800;

  var BASE_CAMAS = 20;
  var BASE_OCUPACION_PCT = 70;
  var BASE_AMBULATORIOS_DIA = 40;

  // Perfiles base por TIPO de centro.
  // Son valores "razonables" para que al cambiar el tipo
  // los campos base se ajusten a la realidad típica de ese centro.
  var PERFIL_TIPO_CENTRO = {
    consultorio_medico: {
      num_camas: 0,
      ocupacion_pct: 0,
      pacientes_ambulatorios_dia: 20,
      caudal_litros_dia: 1500,
      dbo_inicial: 400,
      dqo_inicial: 800,

      banos_pacientes: 1,
      regaderas_pacientes: 0,
      drenajes_clinicos: 0,
      banos_staff: 1,
      regaderas_staff: 0,
      registros_principales: 1,
      drenajes_morgue: 0
    },
    clinica_pequena: {
      num_camas: 10,
      ocupacion_pct: 70,
      pacientes_ambulatorios_dia: 25,
      caudal_litros_dia: 8000,
      dbo_inicial: 400,
      dqo_inicial: 800,

      banos_pacientes: 3,
      regaderas_pacientes: 1,
      drenajes_clinicos: 2,
      banos_staff: 2,
      regaderas_staff: 1,
      registros_principales: 1,
      drenajes_morgue: 0
    },
    day_hospital: {
      num_camas: 0,
      ocupacion_pct: 0,
      pacientes_ambulatorios_dia: 40,
      caudal_litros_dia: 10000,
      dbo_inicial: 400,
      dqo_inicial: 800,

      banos_pacientes: 6,
      regaderas_pacientes: 2,
      drenajes_clinicos: 4,
      banos_staff: 2,
      regaderas_staff: 1,
      registros_principales: 1,
      drenajes_morgue: 1
    },
    laboratorio_clinico: {
      num_camas: 0,
      ocupacion_pct: 0,
      pacientes_ambulatorios_dia: 30,
      caudal_litros_dia: 8000,
      dbo_inicial: 400,
      dqo_inicial: 800,

      banos_pacientes: 2,
      regaderas_pacientes: 0,
      drenajes_clinicos: 1,
      banos_staff: 1,
      regaderas_staff: 0,
      registros_principales: 1,
      drenajes_morgue: 0
    },
    clinica_fertilidad: {
      num_camas: 6,
      ocupacion_pct: 70,
      pacientes_ambulatorios_dia: 15,
      caudal_litros_dia: 7000,
      dbo_inicial: 400,
      dqo_inicial: 800,

      banos_pacientes: 3,
      regaderas_pacientes: 1,
      drenajes_clinicos: 2,
      banos_staff: 2,
      regaderas_staff: 1,
      registros_principales: 1,
      drenajes_morgue: 0
    },
    hospital_general: {
      num_camas: 40,
      ocupacion_pct: 80,
      pacientes_ambulatorios_dia: 80,
      caudal_litros_dia: 50000,
      dbo_inicial: 450,
      dqo_inicial: 900,

      banos_pacientes: 10,
      regaderas_pacientes: 6,
      drenajes_clinicos: 8,
      banos_staff: 4,
      regaderas_staff: 2,
      registros_principales: 2,
      drenajes_morgue: 1
    },
    hospital_especialidad: {
      num_camas: 60,
      ocupacion_pct: 85,
      pacientes_ambulatorios_dia: 100,
      caudal_litros_dia: 65000,
      dbo_inicial: 450,
      dqo_inicial: 900,

      banos_pacientes: 12,
      regaderas_pacientes: 8,
      drenajes_clinicos: 10,
      banos_staff: 5,
      regaderas_staff: 3,
      registros_principales: 3,
      drenajes_morgue: 1
    },
    centro_hemodialisis: {
      num_camas: 0,
      ocupacion_pct: 0,
      pacientes_ambulatorios_dia: 30,
      caudal_litros_dia: 12000,
      dbo_inicial: 450,
      dqo_inicial: 900,

      banos_pacientes: 3,
      regaderas_pacientes: 0,
      drenajes_clinicos: 2,
      banos_staff: 1,
      regaderas_staff: 0,
      registros_principales: 1,
      drenajes_morgue: 0
    },
    imagenologia: {
      num_camas: 0,
      ocupacion_pct: 0,
      pacientes_ambulatorios_dia: 25,
      caudal_litros_dia: 6000,
      dbo_inicial: 400,
      dqo_inicial: 800,

      banos_pacientes: 2,
      regaderas_pacientes: 0,
      drenajes_clinicos: 1,
      banos_staff: 1,
      regaderas_staff: 0,
      registros_principales: 1,
      drenajes_morgue: 0
    },
    hospital_psiquiatrico: {
      num_camas: 50,
      ocupacion_pct: 85,
      pacientes_ambulatorios_dia: 10,
      caudal_litros_dia: 30000,
      dbo_inicial: 400,
      dqo_inicial: 800,

      banos_pacientes: 8,
      regaderas_pacientes: 8,
      drenajes_clinicos: 4,
      banos_staff: 4,
      regaderas_staff: 2,
      registros_principales: 2,
      drenajes_morgue: 0
    },
    otro_centro: {
      num_camas: BASE_CAMAS,
      ocupacion_pct: BASE_OCUPACION_PCT,
      pacientes_ambulatorios_dia: BASE_AMBULATORIOS_DIA,
      caudal_litros_dia: BASE_CAUDAL_L_DIA,
      dbo_inicial: BASE_DBO,
      dqo_inicial: BASE_DQO,

      banos_pacientes: 6,
      regaderas_pacientes: 2,
      drenajes_clinicos: 4,
      banos_staff: 2,
      regaderas_staff: 1,
      registros_principales: 1,
      drenajes_morgue: 1
    }
  };

  var CARGA_MULT = {
    baja: 1.0,
    media: 1.35,
    alta: 1.7
  };

  var MODO_MULT = {
    mantenimiento: 1.0,
    choque: 1.7
  };

  var SEGMENTO_MULT = {
    pequeno: 1.0,
    mediano: 1.3,
    grande: 1.8
  };

  var TIPO_CENTRO_MULT = {
    hospital_general: 1.4,
    hospital_especialidad: 1.5,
    clinica_pequena: 1.0,     // base
    day_hospital: 1.1,
    centro_hemodialisis: 1.4,
    clinica_fertilidad: 1.3,
    laboratorio_clinico: 1.1,
    imagenologia: 1.0,
    hospital_psiquiatrico: 1.2,
    consultorio_medico: 0.8,
    otro_centro: 1.0
  };


  // Piso mínimo mensual por tipo de centro y tamaño (carga baja / mantenimiento)
  // Puedes ajustar estos números según lo que vayas viendo en la práctica.
  var TIPO_MIN_G = {
    consultorio_medico: {
      pequeno: 250,
      mediano: 400,
      grande: 600
    },
    clinica_pequena: {
      pequeno: 400,
      mediano: 700,
      grande: 900
    },
    day_hospital: {
      pequeno: 500,
      mediano: 800,
      grande: 1100
    },
    laboratorio_clinico: {
      pequeno: 400,
      mediano: 800,
      grande: 1200
    },
    clinica_fertilidad: {
      pequeno: 500,
      mediano: 900,
      grande: 1300
    },
    hospital_general: {
      pequeno: 600,
      mediano: 900,
      grande: 1500
    },
    hospital_especialidad: {
      pequeno: 700,
      mediano: 1100,
      grande: 1700
    },
    centro_hemodialisis: {
      pequeno: 500,
      mediano: 900,
      grande: 1300
    },
    imagenologia: {
      pequeno: 300,
      mediano: 500,
      grande: 800
    },
    hospital_psiquiatrico: {
      pequeno: 500,
      mediano: 900,
      grande: 1300
    },
    otro_centro: {
      pequeno: 400,
      mediano: 700,
      grande: 1000
    }
  };




  // Pesos de puntos equivalentes por zona
  var PESOS = {
    banos_pacientes: 1.3,
    regaderas_pacientes: 1.2,
    drenajes_clinicos: 1.4,
    banos_staff: 1.1,
    regaderas_staff: 1.1,
    registros_principales: 2.0,
    drenajes_morgue: 2.2,

    drenajes_cocina: 2.0,
    trampas_grasa: 3.0,
    drenajes_comedor: 1.6,

    drenajes_lavadoras: 2.2,
    drenajes_piso_lavanderia: 1.8,

    drenajes_lab_clinico: 1.7,
    drenajes_banco_sangre: 1.9,
    drenajes_lab_micro: 2.0,
    drenajes_anatomia: 2.2,

    drenajes_hemodialisis: 2.1,
    drenajes_quimio: 2.0,

    drenajes_residuos_ordinarios: 2.0,
    drenajes_residuos_rpbi: 2.2,

    registros_hacia_ptar: 2.3
  };

  // Puntos equivalentes del escenario base (estimado)
  var BASE_PUNTOS_EQ_REF = (function () {
    var b = 0;
    // supuestos de referencia (no visibles para el usuario)
    b += 6 * PESOS.banos_pacientes;
    b += 2 * PESOS.regaderas_pacientes;
    b += 4 * PESOS.drenajes_clinicos;
    b += 2 * PESOS.banos_staff;
    b += 1 * PESOS.regaderas_staff;
    b += 1 * PESOS.registros_principales;
    b += 1 * PESOS.drenajes_morgue;
    return b;
  })();

  // -------------------------
  //  UTILIDADES DOM
  // -------------------------

  function qsa(selector, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(selector));
  }

  function el(tag, attrs) {
    var e = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        e.setAttribute(k, attrs[k]);
      });
    }
    return e;
  }

  function labeledNumber(id, label, value, extraCfg) {
    var wrap = el('label');
    wrap.style.flex = '1 1 220px';
    wrap.style.fontSize = '13px';
    wrap.style.display = 'block';

    var lbl = el('div');
    lbl.style.fontWeight = '600';
    lbl.style.marginBottom = '6px';
    lbl.style.whiteSpace = 'pre-line';
    lbl.innerText = label;

    var input = el('input');
    input.type = 'number';
    input.value = value !== undefined ? value : 0;
    input.min = 0;
    input.style.width = '100%';
    input.style.padding = '8px';
    input.style.border = '1px solid #dcdcdc';
    input.style.borderRadius = '6px';
    input.setAttribute('data-role', id);

    if (extraCfg && extraCfg.step) {
      input.step = extraCfg.step;
    }

    wrap.appendChild(lbl);
    wrap.appendChild(input);
    return wrap;
  }

  function serviceGroup(id, title, description, roleName) {
    var wrap = el('div');
    wrap.style.flex = '1 1 100%';
    wrap.style.borderTop = '1px solid #e0e0e0';
    wrap.style.paddingTop = '8px';
    wrap.style.marginTop = '8px';
    wrap.style.fontSize = '13px';

    var row = el('div');
    row.style.display = 'flex';
    row.style.alignItems = 'center';
    row.style.gap = '8px';

    var chk = el('input');
    chk.type = 'checkbox';
    chk.setAttribute('data-role', roleName || ('svc_' + id));

    var lbl = el('div');
    lbl.style.fontWeight = '600';
    lbl.innerText = title;

    row.appendChild(chk);
    row.appendChild(lbl);
    wrap.appendChild(row);

    if (description) {
      var note = el('div');
      note.style.marginTop = '4px';
      note.style.color = '#555';
      note.innerText = description;
      wrap.appendChild(note);
    }

    var panel = el('div');
    panel.setAttribute('data-service-panel', id);
    panel.style.display = 'none';
    panel.style.marginTop = '6px';
    panel.style.gap = '8px';
    panel.style.flexWrap = 'wrap';

    wrap.appendChild(panel);

    return { wrapper: wrap, checkbox: chk, panel: panel };
  }

  // -------------------------
  //  RENDER DEL WIDGET
  // -------------------------

  function renderWidget(container, cfg) {
    container.innerHTML = '';

    var title = cfg.title || 'Calculadora BACTER spp. – Hospitales, Clínicas y Centros de Salud';

    var h = el('div');
    h.className = 'bacter-title';
    h.style.fontWeight = '800';
    h.style.marginBottom = '8px';
    h.style.fontSize = '24px';
    h.style.textAlign = 'center';
    h.innerText = title;
    container.appendChild(h);

    var form = el('div');
    form.style.display = 'flex';
    form.style.flexWrap = 'wrap';
    form.style.gap = '8px';
    form.style.marginBottom = '10px';

    // ----- Segmento (pequeño / mediano / grande) -----

    var segDiv = el('div');
    segDiv.style.flex = '1 1 220px';
    var segLbl = el('div');
    segLbl.style.fontWeight = '600';
    segLbl.style.marginBottom = '6px';
    segLbl.innerText = 'Tamaño del\ncentro de salud';
    var selSeg = el('select');
    selSeg.setAttribute('data-role', 'segmento_salud');
    selSeg.style.padding = '8px';
    selSeg.style.border = '1px solid #dcdcdc';
    selSeg.style.borderRadius = '6px';

    function addSeg(v, txt) {
      var o = el('option');
      o.value = v;
      o.innerText = txt;
      selSeg.appendChild(o);
    }
    addSeg('pequeno', 'Centro pequeño (clínica / hospital chico)');
    addSeg('mediano', 'Centro mediano');
    addSeg('grande', 'Centro grande / alta complejidad');

    selSeg.value = cfg.defaults.segmento_salud || 'pequeno';

    segDiv.appendChild(segLbl);
    segDiv.appendChild(selSeg);
    form.appendChild(segDiv);

    // ----- Tipo de centro -----

    var tipoDiv = el('div');
    tipoDiv.style.flex = '1 1 260px';
    var tipoLbl = el('div');
    tipoLbl.style.fontWeight = '600';
    tipoLbl.style.marginBottom = '6px';
    tipoLbl.innerText = 'Tipo del\ncentro de salud';
    var selTipo = el('select');
    selTipo.setAttribute('data-role', 'tipo_centro_salud');
    selTipo.style.padding = '8px';
    selTipo.style.border = '1px solid #dcdcdc';
    selTipo.style.borderRadius = '6px';

    function addTipo(v, txt) {
      var o = el('option');
      o.value = v;
      o.innerText = txt;
      selTipo.appendChild(o);
    }

    addTipo('consultorio_medico', 'Consultorio médico (dentista, gine, otorrino, trauma, etc.)');
    addTipo('clinica_pequena', 'Clínica pequeña / corta estancia');
    addTipo('day_hospital', 'Centro de cirugía ambulatoria / day hospital');
    addTipo('laboratorio_clinico', 'Laboratorio clínico / banco de sangre');
    addTipo('clinica_fertilidad', 'Clínica de fertilidad / reproducción asistida');
    addTipo('hospital_general', 'Hospital general (público o privado)');
    addTipo('hospital_especialidad', 'Hospital de especialidad');
    addTipo('centro_hemodialisis', 'Centro de hemodiálisis');
    addTipo('imagenologia', 'Centro de imagenología y diagnóstico');
    addTipo('hospital_psiquiatrico', 'Hospital psiquiátrico / larga estancia');
    addTipo('otro_centro', 'Otro centro médico');

    selTipo.value = cfg.defaults.tipo_centro_salud || 'clinica_pequena';

    tipoDiv.appendChild(tipoLbl);
    tipoDiv.appendChild(selTipo);
    form.appendChild(tipoDiv);

    // ----- Programa de aplicación -----

    var progDiv = el('div');
    progDiv.style.flex = '1 1 220px';
    var progLbl = el('div');
    progLbl.style.fontWeight = '600';
    progLbl.style.marginBottom = '6px';
    progLbl.innerText = 'Programa de\ndosificación';
    var selProg = el('select');
    selProg.setAttribute('data-role', 'programa');
    selProg.style.padding = '8px';
    selProg.style.border = '1px solid #dcdcdc';
    selProg.style.borderRadius = '6px';

    function addProg(v, txt) {
      var o = el('option');
      o.value = v;
      o.innerText = txt;
      selProg.appendChild(o);
    }

    addProg('diaria',    'Diaria (30 aplicaciones/mes)');
    addProg('semanal',   'Semanal (4 aplicaciones/mes)');
    addProg('quincenal', 'Quincenal (2 aplicaciones/mes)');
    addProg('mensual',   'Mensual (1 aplicación/mes)');
    selProg.value = cfg.defaults.programa || 'semanal';

    progDiv.appendChild(progLbl);
    progDiv.appendChild(selProg);
    form.appendChild(progDiv);

    // ----- Perfil general -----

    form.appendChild(
      labeledNumber(
        'num_camas',
        'Nº de camas\ncensables',
        cfg.defaults.num_camas || BASE_CAMAS
      )
    );

    form.appendChild(
      labeledNumber(
        'ocupacion_pct',
        '% ocupación de camas\npromedio por día',
        cfg.defaults.ocupacion_pct || BASE_OCUPACION_PCT,
        { step: '1' }
      )
    );

    form.appendChild(
      labeledNumber(
        'pacientes_ambulatorios_dia',
        'Pacientes ambulatorios\npromedio por día',
        cfg.defaults.pacientes_ambulatorios_dia || BASE_AMBULATORIOS_DIA
      )
    );

    form.appendChild(
      labeledNumber(
        'caudal_litros_dia',
        'Caudal promedio total de aguas residuales (L/día) opcional',
        cfg.defaults.caudal_litros_dia || BASE_CAUDAL_L_DIA,
        { step: '1' }
      )
    );

    form.appendChild(
      labeledNumber(
        'dbo_inicial',
        'DBO inicial aproximada\n(mg/L) opcional',
        cfg.defaults.dbo_inicial || BASE_DBO,
        { step: '1' }
      )
    );

    form.appendChild(
      labeledNumber(
        'dqo_inicial',
        'DQO inicial aproximada\n(mg/L) opcional',
        cfg.defaults.dqo_inicial || BASE_DQO,
        { step: '1' }
      )
    );

    // ----- Puntos básicos (siempre visibles) -----

    var sepBasicos = el('div');
    sepBasicos.style.flex = '1 1 100%';
    sepBasicos.style.marginTop = '10px';
    sepBasicos.style.fontWeight = '700';
    sepBasicos.style.fontSize = '15px';
    sepBasicos.innerText = 'Puntos básicos en el hospital / clínica';
    form.appendChild(sepBasicos);

    form.appendChild(
      labeledNumber(
        'banos_pacientes',
        'Nº de baños áreas de atención\n(para pacientes o usuarios)',
        cfg.defaults.banos_pacientes || 0
      )
    );

    form.appendChild(
      labeledNumber(
        'regaderas_pacientes',
        'Nº de baños con regadera para pacientes (hospitalización)',
        cfg.defaults.regaderas_pacientes || 0
      )
    );

    form.appendChild(
      labeledNumber(
        'drenajes_clinicos',
        'Nº de drenajes de piso (pasillos, UCI, quirófanos, recuperación)',
        cfg.defaults.drenajes_clinicos || 0
      )
    );

    form.appendChild(
      labeledNumber(
        'banos_staff',
        'Nº de baños en vestidores\n(médicos, enfermería y personal)',
        cfg.defaults.banos_staff || 0
      )
    );

    form.appendChild(
      labeledNumber(
        'regaderas_staff',
        'Nº de regaderas en vestidores\n(médicos, enfermería y personal)',
        cfg.defaults.regaderas_staff || 0
      )
    );

    form.appendChild(
      labeledNumber(
        'registros_principales',
        'Nº de registros principales\nantes de fosa / descarga',
        cfg.defaults.registros_principales || 0
      )
    );

    form.appendChild(
      labeledNumber(
        'drenajes_morgue',
        'Nº de drenajes en anatomía patológica y morgue\n(drenajes donde descargan fluidos tratados)',
        cfg.defaults.drenajes_morgue || 0
      )
    );

    // ----- Servicios opcionales -----

    var sepServ = el('div');
    sepServ.style.flex = '1 1 100%';
    sepServ.style.marginTop = '14px';
    sepServ.style.fontWeight = '700';
    sepServ.style.fontSize = '15px';
    sepServ.innerText = 'Servicios opcionales (activa solo los que tenga tu centro)';
    form.appendChild(sepServ);

    // Cocina / cafetería
    var svcCocina = serviceGroup(
      'cocina',
      'Cocina hospitalaria, cafetería y trampas de grasa',
      'Actívalo si el centro tiene cocina propia, cafetería interna o trampas de grasa.'
    );
    form.appendChild(svcCocina.wrapper);
    svcCocina.panel.appendChild(
      labeledNumber(
        'drenajes_cocina',
        'Nº de drenajes en cocina principal\n(canaletas, coladeras, registros)',
        cfg.defaults.drenajes_cocina || 0
      )
    );
    svcCocina.panel.appendChild(
      labeledNumber(
        'trampas_grasa',
        'Nº de trampas de grasa\n(cocina, cafetería, snack)',
        cfg.defaults.trampas_grasa || 0
      )
    );
    svcCocina.panel.appendChild(
      labeledNumber(
        'drenajes_comedor',
        'Nº de drenajes en comedor\no cafetería',
        cfg.defaults.drenajes_comedor || 0
      )
    );

    // Lavandería
    var svcLav = serviceGroup(
      'lavanderia',
      'Lavandería hospitalaria',
      'Actívalo si el centro cuenta con lavandería propia para ropa hospitalaria.'
    );
    form.appendChild(svcLav.wrapper);
    svcLav.panel.appendChild(
      labeledNumber(
        'drenajes_lavadoras',
        'Nº de drenajes de lavadoras industriales\n o túneles de lavado',
        cfg.defaults.drenajes_lavadoras || 0
      )
    );
    svcLav.panel.appendChild(
      labeledNumber(
        'drenajes_piso_lavanderia',
        'Nº de drenajes de piso en lavandería\n(ropa sucia / ropa limpia)',
        cfg.defaults.drenajes_piso_lavanderia || 0
      )
    );

    // Laboratorios
    var svcLab = serviceGroup(
      'laboratorios',
      'Laboratorios, banco de sangre y anatomía patológica',
      'Actívalo si el centro tiene laboratorios o banco de sangre que descargan a drenaje sanitario.'
    );
    form.appendChild(svcLab.wrapper);
    svcLab.panel.appendChild(
      labeledNumber(
        'drenajes_lab_clinico',
        'Nº de drenajes en\nlaboratorio clínico',
        cfg.defaults.drenajes_lab_clinico || 0
      )
    );
    svcLab.panel.appendChild(
      labeledNumber(
        'drenajes_banco_sangre',
        'Nº de drenajes en\nbanco de sangre',
        cfg.defaults.drenajes_banco_sangre || 0
      )
    );
    svcLab.panel.appendChild(
      labeledNumber(
        'drenajes_lab_micro',
        'Nº de drenajes en laboratorio de\nmicrobiología / virología',
        cfg.defaults.drenajes_lab_micro || 0
      )
    );
    svcLab.panel.appendChild(
      labeledNumber(
        'drenajes_anatomia',
        'Nº de drenajes adicionales en\nanatomía patológica / histopatología',
        cfg.defaults.drenajes_anatomia || 0
      )
    );

    // Hemodiálisis / quimio
    var svcHemo = serviceGroup(
      'hemodialisis',
      'Unidades de hemodiálisis y quimioterapia / infusión',
      'Actívalo si hay drenajes donde descargan efluentes de hemodiálisis o salas de infusión.'
    );
    form.appendChild(svcHemo.wrapper);
    svcHemo.panel.appendChild(
      labeledNumber(
        'drenajes_hemodialisis',
        'Nº de drenajes en unidad\nde hemodiálisis',
        cfg.defaults.drenajes_hemodialisis || 0
      )
    );
    svcHemo.panel.appendChild(
      labeledNumber(
        'drenajes_quimio',
        'Nº de drenajes en salas de\nquimioterapia / infusión',
        cfg.defaults.drenajes_quimio || 0
      )
    );

    // Residuos
    var svcRes = serviceGroup(
      'residuos',
      'Cuartos de residuos y compactadoras',
      'Actívalo si los cuartos de residuos descargan a drenaje sanitario.'
    );
    form.appendChild(svcRes.wrapper);
    svcRes.panel.appendChild(
      labeledNumber(
        'drenajes_residuos_ordinarios',
        'Nº de drenajes en cuartos de residuos ordinarios\n(compactadoras, basura general)',
        cfg.defaults.drenajes_residuos_ordinarios || 0
      )
    );
    svcRes.panel.appendChild(
      labeledNumber(
        'drenajes_residuos_rpbi',
        'Nº de drenajes en cuartos de RPBI\n(solo líneas compatibles con descarga sanitaria)',
        cfg.defaults.drenajes_residuos_rpbi || 0
      )
    );

    // PTAR (como servicio opcional)
    var svcPtar = serviceGroup(
      'ptar',
      'PTAR propia y registros hacia tratamiento',
      'Actívalo si el centro descarga a una planta de tratamiento propia.',
      'tiene_ptar'
    );
    form.appendChild(svcPtar.wrapper);
    svcPtar.panel.appendChild(
      labeledNumber(
        'caudal_ptar_m3_dia',
        'Caudal medio que llega a la PTAR\n(m³/día) opcional',
        cfg.defaults.caudal_ptar_m3_dia || 0,
        { step: '0.1' }
      )
    );
    svcPtar.panel.appendChild(
      labeledNumber(
        'registros_hacia_ptar',
        'Nº de registros que alimentan\nla fosa / PTAR',
        cfg.defaults.registros_hacia_ptar || 0
      )
    );

    // Químicos agresivos (como servicio opcional)
    var svcQuim = serviceGroup(
      'quimicos',
      'Uso frecuente de químicos agresivos en drenajes',
      'Actívalo si se usan con frecuencia sosa cáustica, cloro fuerte o desengrasantes muy agresivos en drenajes.',
      'quimicos'
    );
    form.appendChild(svcQuim.wrapper);
    // No necesita campos numéricos

    // ---- activar servicios según defaults ----

    [
      { svc: svcCocina, flag: cfg.defaults.servicio_cocina },
      { svc: svcLav,    flag: cfg.defaults.servicio_lavanderia },
      { svc: svcLab,    flag: cfg.defaults.servicio_laboratorios },
      { svc: svcHemo,   flag: cfg.defaults.servicio_hemodialisis },
      { svc: svcRes,    flag: cfg.defaults.servicio_residuos },
      { svc: svcPtar,   flag: cfg.defaults.tiene_ptar },
      { svc: svcQuim,   flag: cfg.defaults.quimicos }
    ].forEach(function (item) {
      if (!item.svc) return;
      if (item.flag) {
        item.svc.checkbox.checked = true;
        item.svc.panel.style.display = 'flex';
      }
      item.svc.checkbox.addEventListener('change', function () {
        item.svc.panel.style.display = item.svc.checkbox.checked ? 'flex' : 'none';
      });
    });

    container.appendChild(form);

    // Resultado
    var res = el('div');
    res.setAttribute('data-role', 'resultado');
    res.style.marginTop = '12px';
    res.style.padding = '12px';
    res.style.background = '#f8f9fa';
    res.style.borderRadius = '6px';
    res.style.display = 'none';
    container.appendChild(res);

    // ----- Función para aplicar perfil por tipo de centro -----

    function setRoleValue(role, value) {
      var node = container.querySelector('[data-role="' + role + '"]');
      if (!node || value === undefined || value === null) return;
      node.value = value;
    }

    function aplicarPerfilDesdeTipo(tipo) {
      var perfil = PERFIL_TIPO_CENTRO[tipo] || PERFIL_TIPO_CENTRO.otro_centro;
      if (!perfil) return;

      setRoleValue('num_camas', perfil.num_camas);
      setRoleValue('ocupacion_pct', perfil.ocupacion_pct);
      setRoleValue('pacientes_ambulatorios_dia', perfil.pacientes_ambulatorios_dia);
      setRoleValue('caudal_litros_dia', perfil.caudal_litros_dia);
      setRoleValue('dbo_inicial', perfil.dbo_inicial);
      setRoleValue('dqo_inicial', perfil.dqo_inicial);

      setRoleValue('banos_pacientes', perfil.banos_pacientes);
      setRoleValue('regaderas_pacientes', perfil.regaderas_pacientes);
      setRoleValue('drenajes_clinicos', perfil.drenajes_clinicos);
      setRoleValue('banos_staff', perfil.banos_staff);
      setRoleValue('regaderas_staff', perfil.regaderas_staff);
      setRoleValue('registros_principales', perfil.registros_principales);
      setRoleValue('drenajes_morgue', perfil.drenajes_morgue);
    }

    // Aplicar perfil inicial según el tipo seleccionado
    aplicarPerfilDesdeTipo(selTipo.value);

    // Eventos
    qsa('input[type="number"]', container).forEach(function (inp) {
      inp.addEventListener('input', function () {
        doCalc(container, cfg);
      });
    });
    qsa('select', container).forEach(function (sel) {
      sel.addEventListener('change', function () {
        doCalc(container, cfg);
      });
    });

    // Cuando cambia el TIPO de centro, reasignamos perfil y recalculamos
    selTipo.addEventListener('change', function () {
      aplicarPerfilDesdeTipo(selTipo.value);
      doCalc(container, cfg);
    });

    ['quimicos', 'tiene_ptar', 'segmento_salud', 'tipo_centro_salud'].forEach(function (role) {
      var n = container.querySelector('[data-role="' + role + '"]');
      if (n) n.addEventListener('change', function () {
        doCalc(container, cfg);
      });
    });

    doCalc(container, cfg);
  }

    // -------------------------
  //  LÓGICA DE CÁLCULO
  // -------------------------

  function doCalc(container, cfg) {
    function getVal(role, asNum) {
      var node = container.querySelector('[data-role="' + role + '"]');
      if (!node) return asNum ? 0 : '';
      if (node.type === 'checkbox') return node.checked;
      var v = node.value;
      if (asNum) return parseFloat(v || 0) || 0;
      return v || '';
    }

    function formatGrKg(g) {
      if (!g || g <= 0) return '0 g';
      if (g >= 1000) {
        var kg = g / 1000;
        var txt = kg.toFixed(2).replace(/\.00$/, '');
        return txt + ' kg';
      }
      return Math.round(g) + ' g';
    }

    function formatMl(ml) {
      if (!ml || ml <= 0) return '0 mL';

      // Redondeo a múltiplos de 250 mL (0.25 L)
      var stepMl = 250; // 250 mL
      var rounded = Math.round(ml / stepMl) * stepMl;

      // Si después del redondeo quedara en 0 pero había algo de volumen,
      // subimos al mínimo de 250 mL para no perder la referencia.
      if (rounded === 0 && ml > 0) {
        rounded = stepMl;
      }

      // Mostrar en mL si es < 1000 mL, en L si es 1 L o más,
      // siempre con pasos de 250 mL / 0.25 L.
      if (rounded < 1000) {
        return rounded + ' mL';
      } else {
        var litros = rounded / 1000;
        var txt = litros
          .toFixed(2)              // 1.25, 1.50, etc.
          .replace(/\.00$/, '')    // 1
          .replace(/(\.\d)0$/, '$1'); // 1.5
        return txt + ' L';
      }
    }


    function calcPorPunto(gAplic, mlAplic, nPuntos) {
      if (!nPuntos || nPuntos <= 0 || gAplic <= 0)
        return { g: 0, ml: 0 };
      var gP = gAplic / nPuntos;
      var mlP = mlAplic / nPuntos;
      return {
        g: Math.round(gP * 10) / 10,
        ml: Math.round(mlP / 10) * 10
      };
    }

    // ---- Lectura de selects y flags ----

    var segmento   = getVal('segmento_salud') || cfg.defaults.segmento_salud || 'pequeno';
    var tipoCentro = getVal('tipo_centro_salud') || cfg.defaults.tipo_centro_salud || 'clinica_pequena';
    var programa   = getVal('programa') || cfg.defaults.programa || 'semanal';
    var carga      = getVal('carga') || cfg.defaults.carga || 'baja';
    var modo       = getVal('modo') || cfg.defaults.modo || 'mantenimiento';

    var quimicos   = !!getVal('quimicos');
    var tienePtar  = !!getVal('tiene_ptar');

    // ---- Perfil general ----

    var numCamas = getVal('num_camas', true);
    if (numCamas < 0) numCamas = 0;

    var ocupacionPct = getVal('ocupacion_pct', true);
    if (ocupacionPct < 0) ocupacionPct = 0;
    if (ocupacionPct > 100) {
      ocupacionPct = 100;
      var inpOcup = container.querySelector('[data-role="ocupacion_pct"]');
      if (inpOcup) inpOcup.value = 100;
    }

    var ambDia = getVal('pacientes_ambulatorios_dia', true);
    if (ambDia < 0) ambDia = 0;

    var caudalDia = getVal('caudal_litros_dia', true);
    var dbo = getVal('dbo_inicial', true);
    var dqo = getVal('dqo_inicial', true);

    var caudalPtarM3 = getVal('caudal_ptar_m3_dia', true);

    // ---- Puntos de aplicación (nº de puntos) ----

    var nBanosPac   = getVal('banos_pacientes', true);
    var nRegPac     = getVal('regaderas_pacientes', true);
    var nDrClin     = getVal('drenajes_clinicos', true);
    var nBanosStaff = getVal('banos_staff', true);
    var nRegStaff   = getVal('regaderas_staff', true);
    var nRegPpal    = getVal('registros_principales', true);
    var nMorgue     = getVal('drenajes_morgue', true);

    var nDrCocina   = getVal('drenajes_cocina', true);
    var nTrampas    = getVal('trampas_grasa', true);
    var nDrComedor  = getVal('drenajes_comedor', true);

    var nDrLavadoras = getVal('drenajes_lavadoras', true);
    var nDrLavPiso   = getVal('drenajes_piso_lavanderia', true);

    var nDrLabClin  = getVal('drenajes_lab_clinico', true);
    var nDrBanco    = getVal('drenajes_banco_sangre', true);
    var nDrLabMicro = getVal('drenajes_lab_micro', true);
    var nDrAnat     = getVal('drenajes_anatomia', true);

    var nDrHemo     = getVal('drenajes_hemodialisis', true);
    var nDrQuimio   = getVal('drenajes_quimio', true);

    var nDrResOrd   = getVal('drenajes_residuos_ordinarios', true);
    var nDrResRpbi  = getVal('drenajes_residuos_rpbi', true);

    var nRegPtar    = getVal('registros_hacia_ptar', true);

    // ---- Puntos equivalentes (n * peso) ----

    function puntosZona(n, pesoKey) {
      if (!n || n <= 0) return 0;
      var p = PESOS[pesoKey] || 1.0;
      return n * p;
    }

    var puntosBanosPac   = puntosZona(nBanosPac, 'banos_pacientes');
    var puntosRegPac     = puntosZona(nRegPac, 'regaderas_pacientes');
    var puntosDrClin     = puntosZona(nDrClin, 'drenajes_clinicos');
    var puntosBanosStaff = puntosZona(nBanosStaff, 'banos_staff');
    var puntosRegStaff   = puntosZona(nRegStaff, 'regaderas_staff');
    var puntosRegPpal    = puntosZona(nRegPpal, 'registros_principales');
    var puntosMorgue     = puntosZona(nMorgue, 'drenajes_morgue');

    var puntosDrCocina   = puntosZona(nDrCocina, 'drenajes_cocina');
    var puntosTrampas    = puntosZona(nTrampas, 'trampas_grasa');
    var puntosDrComedor  = puntosZona(nDrComedor, 'drenajes_comedor');

    var puntosDrLavadoras = puntosZona(nDrLavadoras, 'drenajes_lavadoras');
    var puntosDrLavPiso   = puntosZona(nDrLavPiso, 'drenajes_piso_lavanderia');

    var puntosDrLabClin  = puntosZona(nDrLabClin, 'drenajes_lab_clinico');
    var puntosDrBanco    = puntosZona(nDrBanco, 'drenajes_banco_sangre');
    var puntosDrLabMicro = puntosZona(nDrLabMicro, 'drenajes_lab_micro');
    var puntosDrAnat     = puntosZona(nDrAnat, 'drenajes_anatomia');

    var puntosDrHemo     = puntosZona(nDrHemo, 'drenajes_hemodialisis');
    var puntosDrQuimio   = puntosZona(nDrQuimio, 'drenajes_quimio');

    var puntosDrResOrd   = puntosZona(nDrResOrd, 'drenajes_residuos_ordinarios');
    var puntosDrResRpbi  = puntosZona(nDrResRpbi, 'drenajes_residuos_rpbi');

    var puntosRegPtar    = puntosZona(nRegPtar, 'registros_hacia_ptar');

    var puntosEq =
      puntosBanosPac   +
      puntosRegPac     +
      puntosDrClin     +
      puntosBanosStaff +
      puntosRegStaff   +
      puntosRegPpal    +
      puntosMorgue     +
      puntosDrCocina   +
      puntosTrampas    +
      puntosDrComedor  +
      puntosDrLavadoras +
      puntosDrLavPiso   +
      puntosDrLabClin  +
      puntosDrBanco    +
      puntosDrLabMicro +
      puntosDrAnat     +
      puntosDrHemo     +
      puntosDrQuimio   +
      puntosDrResOrd   +
      puntosDrResRpbi  +
      puntosRegPtar;

    // NOTA: si puntosEq = 0, lo dejamos en 0.
    // Eso significa: se muestra solo recomendación general y la dosis será el piso.

    // ---- Pisos mínimos (segmento + tipo de centro) ----

    var minSeg = SEGMENTO_MIN_G[segmento] || 0;

    var minTipo = 0;
    if (TIPO_MIN_G[tipoCentro] && TIPO_MIN_G[tipoCentro][segmento] != null) {
      minTipo = TIPO_MIN_G[tipoCentro][segmento];
    }

    var piso = Math.max(minSeg, minTipo);
    if (piso <= 0) piso = BASE_G_PEQUENO; // fallback por si algo falta

    // -----------------------------------------
    //  Extra por punto equivalente
    // -----------------------------------------
    // Regla: cada "punto equivalente" suma un poco de dosis
    // arriba del piso. Ajustable:
    //   - Si quieres que suba más rápido: usa piso/15
    //   - Si quieres que suba más despacio: usa piso/30, etc.

    var extraPorPuntoEq = piso / 20;
    if (extraPorPuntoEq < 1) extraPorPuntoEq = 1; // mínimo 1 g por eq

    var extraBase = puntosEq * extraPorPuntoEq; // g/mes antes de multiplicadores

    // ---- Multiplicadores (NO bajan del piso, solo escalan el extra) ----

    var multSeg   = SEGMENTO_MULT[segmento] || 1.0;
    var multTipo  = TIPO_CENTRO_MULT[tipoCentro] || 1.0;

    // Capacidad equivalente
    var camasEqRef = BASE_CAMAS * (BASE_OCUPACION_PCT / 100) + BASE_AMBULATORIOS_DIA * 0.5;
    var camasEq    = numCamas * (ocupacionPct / 100) + ambDia * 0.5;
    var multCapacidad = 1.0;
    if (camasEqRef > 0 && camasEq > 0) {
      var ratioCap = camasEq / camasEqRef;
      if (ratioCap < 1.0) ratioCap = 1.0; // ya no bajamos
      if (ratioCap > 2.0) ratioCap = 2.0;
      multCapacidad = ratioCap;
    }

    // Caudal
    var multCaudal = 1.0;
    if (caudalDia > 0) {
      var ratioCaudal = caudalDia / BASE_CAUDAL_L_DIA;
      if (ratioCaudal < 1.0) ratioCaudal = 1.0;
      if (ratioCaudal > 2.0) ratioCaudal = 2.0;
      multCaudal = ratioCaudal;
    }

    // DBO / DQO
    var multDboDqo = 1.0;
    if (dbo > 0 || dqo > 0) {
      var rDbo = dbo > 0 ? dbo / BASE_DBO : 1.0;
      var rDqo = dqo > 0 ? dqo / BASE_DQO : 1.0;
      var rMax = Math.max(rDbo, rDqo);
      if (rMax < 0.7) rMax = 0.7;
      if (rMax > 1.8) rMax = 1.8;
      multDboDqo = rMax;
    }

    // PTAR
    var multPtar = 1.0;
    if (tienePtar) {
      var basePtarCaudal = BASE_CAUDAL_L_DIA / 1000; // ~15 m³/día
      var ratioPtar = caudalPtarM3 > 0 ? caudalPtarM3 / basePtarCaudal : 1.0;
      if (ratioPtar < 0.7) ratioPtar = 0.7;
      if (ratioPtar > 2.0) ratioPtar = 2.0;
      multPtar = 1.0 + 0.15 * ratioPtar;
    }

    var multCarga = CARGA_MULT[carga] || 1.0;
    var multModo  = MODO_MULT[modo]   || 1.0;
    var multQuim  = quimicos ? 1.25 : 1.0;

    var multTotal =
      multSeg *
      multTipo *
      multCapacidad *
      multCaudal *
      multDboDqo *
      multPtar *
      multCarga *
      multModo *
      multQuim;

    // ---- Dosis mensual ajustada ----
    // Piso + extra (que ya depende de nº de puntos y de multipliers)

    var ajustado = piso + (extraBase * multTotal);
    ajustado = Math.round(ajustado);

    // ---- Programa: aplicaciones por mes ----

    var appsMes = 4;
    var labelPrograma = 'semanal';

    if (programa === 'diaria') {
      appsMes = 30;
      labelPrograma = 'diaria';
    } else if (programa === 'quincenal') {
      appsMes = 2;
      labelPrograma = 'quincenal';
    } else if (programa === 'mensual') {
      appsMes = 1;
      labelPrograma = 'mensual';
    }

    var gPorAplicacion = ajustado / appsMes;

    // ---- Solución madre ----
    // ---- Solución madre (más concentrada y con redondeo en cuartos de litro) ----
    // Regla base: ~1 L de solución madre por cada 80 g de producto.
    var litrosSolAplic = gPorAplicacion > 0 ? gPorAplicacion / 80 : 0;

    // Mínimo práctico: 0.25 L por evento si hay producto que aplicar.
    if (litrosSolAplic < 0.25 && gPorAplicacion > 0) litrosSolAplic = 0.25;

    // Redondeamos a múltiplos de 0.25 L (250 mL) para facilitar la preparación.
    if (litrosSolAplic > 0) {
      var stepL = 0.25; // cuartos de litro
      var steps = litrosSolAplic / stepL;
      var low = Math.floor(steps) * stepL;
      var high = Math.ceil(steps) * stepL;
      var distLow = Math.abs(litrosSolAplic - low);
      var distHigh = Math.abs(litrosSolAplic - high);
      litrosSolAplic = distHigh < distLow ? high : low;
      if (litrosSolAplic <= 0) litrosSolAplic = stepL;
    }

    var totalMlSolAplic = litrosSolAplic * 1000;


    function mlZona(gZonaAplic) {
      if (gPorAplicacion <= 0 || totalMlSolAplic <= 0) return 0;
      return Math.round((totalMlSolAplic * gZonaAplic) / gPorAplicacion);
    }

    // ---- Reparto por zonas (g mensuales) ----

    var g = {
      banosPac: 0, regPac: 0, drClin: 0, banosStaff: 0, regStaff: 0,
      regPpal: 0, morgue: 0,

      drCocina: 0, trampas: 0, drComedor: 0,
      drLavadoras: 0, drLavPiso: 0,
      drLabClin: 0, drBanco: 0, drLabMicro: 0, drAnat: 0,
      drHemo: 0, drQuimio: 0,
      drResOrd: 0, drResRpbi: 0,
      regPtar: 0
    };

    if (puntosEq > 0) {
      g.banosPac   = Math.round(ajustado * (puntosBanosPac   / puntosEq));
      g.regPac     = Math.round(ajustado * (puntosRegPac     / puntosEq));
      g.drClin     = Math.round(ajustado * (puntosDrClin     / puntosEq));
      g.banosStaff = Math.round(ajustado * (puntosBanosStaff / puntosEq));
      g.regStaff   = Math.round(ajustado * (puntosRegStaff   / puntosEq));
      g.regPpal    = Math.round(ajustado * (puntosRegPpal    / puntosEq));
      g.morgue     = Math.round(ajustado * (puntosMorgue     / puntosEq));

      g.drCocina   = Math.round(ajustado * (puntosDrCocina   / puntosEq));
      g.trampas    = Math.round(ajustado * (puntosTrampas    / puntosEq));
      g.drComedor  = Math.round(ajustado * (puntosDrComedor  / puntosEq));

      g.drLavadoras = Math.round(ajustado * (puntosDrLavadoras / puntosEq));
      g.drLavPiso   = Math.round(ajustado * (puntosDrLavPiso   / puntosEq));

      g.drLabClin  = Math.round(ajustado * (puntosDrLabClin  / puntosEq));
      g.drBanco    = Math.round(ajustado * (puntosDrBanco    / puntosEq));
      g.drLabMicro = Math.round(ajustado * (puntosDrLabMicro / puntosEq));
      g.drAnat     = Math.round(ajustado * (puntosDrAnat     / puntosEq));

      g.drHemo     = Math.round(ajustado * (puntosDrHemo     / puntosEq));
      g.drQuimio   = Math.round(ajustado * (puntosDrQuimio   / puntosEq));

      g.drResOrd   = Math.round(ajustado * (puntosDrResOrd   / puntosEq));
      g.drResRpbi  = Math.round(ajustado * (puntosDrResRpbi  / puntosEq));

      g.regPtar    = Math.round(ajustado * (puntosRegPtar    / puntosEq));

      // Ajuste por redondeos
      var sumaAsignada = 0;
      Object.keys(g).forEach(function (k) { sumaAsignada += g[k]; });
      var diff = ajustado - sumaAsignada;
      if (diff !== 0) {
        g.banosPac += diff;
        if (g.banosPac < 0) g.banosPac = 0;
      }
    }

    // ---- Dosis por evento / mL por zona ----

    function zonaAplic(gZonaTotal) {
      var gA = gZonaTotal / appsMes;
      var mlA = mlZona(gA);
      return { gAplic: gA, mlAplic: mlA };
    }

    var z = {
      banosPac: zonaAplic(g.banosPac),
      regPac: zonaAplic(g.regPac),
      drClin: zonaAplic(g.drClin),
      banosStaff: zonaAplic(g.banosStaff),
      regStaff: zonaAplic(g.regStaff),
      regPpal: zonaAplic(g.regPpal),
      morgue: zonaAplic(g.morgue),

      drCocina: zonaAplic(g.drCocina),
      trampas: zonaAplic(g.trampas),
      drComedor: zonaAplic(g.drComedor),

      drLavadoras: zonaAplic(g.drLavadoras),
      drLavPiso: zonaAplic(g.drLavPiso),

      drLabClin: zonaAplic(g.drLabClin),
      drBanco: zonaAplic(g.drBanco),
      drLabMicro: zonaAplic(g.drLabMicro),
      drAnat: zonaAplic(g.drAnat),

      drHemo: zonaAplic(g.drHemo),
      drQuimio: zonaAplic(g.drQuimio),

      drResOrd: zonaAplic(g.drResOrd),
      drResRpbi: zonaAplic(g.drResRpbi),

      regPtar: zonaAplic(g.regPtar)
    };

    var pp = {
      banosPac:   calcPorPunto(z.banosPac.gAplic,   z.banosPac.mlAplic,   nBanosPac),
      regPac:     calcPorPunto(z.regPac.gAplic,     z.regPac.mlAplic,     nRegPac),
      drClin:     calcPorPunto(z.drClin.gAplic,     z.drClin.mlAplic,     nDrClin),
      banosStaff: calcPorPunto(z.banosStaff.gAplic, z.banosStaff.mlAplic, nBanosStaff),
      regStaff:   calcPorPunto(z.regStaff.gAplic,   z.regStaff.mlAplic,   nRegStaff),
      regPpal:    calcPorPunto(z.regPpal.gAplic,    z.regPpal.mlAplic,    nRegPpal),
      morgue:     calcPorPunto(z.morgue.gAplic,     z.morgue.mlAplic,     nMorgue),

      drCocina:   calcPorPunto(z.drCocina.gAplic,   z.drCocina.mlAplic,   nDrCocina),
      trampas:    calcPorPunto(z.trampas.gAplic,    z.trampas.mlAplic,    nTrampas),
      drComedor:  calcPorPunto(z.drComedor.gAplic,  z.drComedor.mlAplic,  nDrComedor),

      drLavadoras: calcPorPunto(z.drLavadoras.gAplic, z.drLavadoras.mlAplic, nDrLavadoras),
      drLavPiso:   calcPorPunto(z.drLavPiso.gAplic,   z.drLavPiso.mlAplic,   nDrLavPiso),

      drLabClin:  calcPorPunto(z.drLabClin.gAplic,  z.drLabClin.mlAplic,  nDrLabClin),
      drBanco:    calcPorPunto(z.drBanco.gAplic,    z.drBanco.mlAplic,    nDrBanco),
      drLabMicro: calcPorPunto(z.drLabMicro.gAplic, z.drLabMicro.mlAplic, nDrLabMicro),
      drAnat:     calcPorPunto(z.drAnat.gAplic,     z.drAnat.mlAplic,     nDrAnat),

      drHemo:     calcPorPunto(z.drHemo.gAplic,     z.drHemo.mlAplic,     nDrHemo),
      drQuimio:   calcPorPunto(z.drQuimio.gAplic,   z.drQuimio.mlAplic,   nDrQuimio),

      drResOrd:   calcPorPunto(z.drResOrd.gAplic,   z.drResOrd.mlAplic,   nDrResOrd),
      drResRpbi:  calcPorPunto(z.drResRpbi.gAplic,  z.drResRpbi.mlAplic,  nDrResRpbi),

      regPtar:    calcPorPunto(z.regPtar.gAplic,    z.regPtar.mlAplic,    nRegPtar)
    };

    // -------------------------
    //  SALIDA
    // -------------------------

    var resDiv = container.querySelector('[data-role="resultado"]');
    var html = '';

    var etiquetaSeg =
      segmento === 'pequeno'
        ? 'Centro pequeño'
        : segmento === 'mediano'
        ? 'Centro mediano'
        : 'Centro grande / alta complejidad';

    html +=
      '<div style="font-size:18px;margin-bottom:4px;">' +
      'Dosis total recomendada para tu centro de salud: ' +
      '<span style="font-size:24px;font-weight:900;color:#0b3d91;">' +
      formatGrKg(ajustado) +
      '</span> al mes' +
      '</div>';

    html +=
      '<div style="font-size:14px;color:#333;margin-bottom:6px;">' +
      'Tamaño seleccionado: <strong>' + etiquetaSeg + '</strong>. ' +
      'Programa de dosificación: <strong>' + labelPrograma + '</strong> (' +
      appsMes + ' aplicación(es) por mes).' +
      '</div>';

    var sufijoProg =
      programa === 'diaria'
        ? ' (dosis diaria)'
        : programa === 'semanal'
        ? ' (dosis semanal)'
        : programa === 'quincenal'
        ? ' (dosis quincenal)'
        : ' (dosis mensual)';

    html +=
      '<div style="font-size:14px;color:#333;margin-bottom:10px;">' +
      'Dosis total por evento' +
      sufijoProg +
      ': <strong>' +
      formatGrKg(gPorAplicacion) +
      '</strong>. ' +
      (litrosSolAplic > 0
        ? 'Disuélvela en aproximadamente <strong>' +
          litrosSolAplic.toFixed(1).replace(/\.0$/, '') +
          ' L</strong> de agua a temperatura ambiente para preparar la <strong>solución madre</strong>. '
        : ''
      ) +
      '<br><span style="font-size:14px;color:#0b3d91;">' +
      '<strong>Nota:</strong> Puedes redondear un poco la dosis para facilitar la medición, ' +
      'pero mantén el orden de magnitud y la frecuencia de aplicación.' +
      '</span>' +
      '</div>';

    html +=
      '<div style="margin-top:8px;font-size:16px;"><strong>Cómo repartir la dosis en tu hospital o clínica:</strong></div>' +
      '<div style="font-size:14px;color:#333;margin-bottom:6px;">' +
      'Debajo se mostrarán las dosis sugeridas de acuerdo con los puntos que hayas indicado en los campos anteriores. ' +
      'Si solo llenas los datos básicos, verás una recomendación general de aplicación; conforme agregues más servicios, drenajes y áreas específicas, ' +
      'las indicaciones se irán ajustando para ser más precisas y adaptadas a la realidad de tu centro de salud.' +
      '</div>';

    function addZonaBlock(title, gTotal, dataZona, nPuntos, ppZona) {
      if (!nPuntos || nPuntos <= 0) return;
      if (!gTotal || gTotal <= 0) return;

      var gAplic = dataZona.gAplic;
      var mlZonaAplic = dataZona.mlAplic;
      var gPorPunto = ppZona.g || 0;
      var mlPorPunto = ppZona.ml || 0;

      html +=
        '<div style="margin-top:6px;font-size:14px;">' +
        '<strong>' + title + '</strong>:<br>' +
        '• Dosis mensual estimada: <strong>' +
        formatGrKg(gTotal) +
        '</strong>.<br>' +
        '• Cantidad ' + labelPrograma + ' : <strong>' +
        formatGrKg(gAplic) +
        '</strong> &mdash; Se diluyen en <strong>' +
        formatMl(mlZonaAplic) +
        '</strong> de agua a temperatura ambiente.<br> ' +
        '• Verter ' +
         formatMl(mlPorPunto) +
        ' en cada punto, en total son: ' +
        nPuntos +
        '</strong> puntos.'
        '</div>';
    }

    // Zonas básicas
    addZonaBlock(
      'Baños de pacientes y áreas de atención (habitaciones, salas de espera, urgencias, consulta externa)',
      g.banosPac, z.banosPac, nBanosPac, pp.banosPac
    );
    addZonaBlock(
      'Regaderas de pacientes (hospitalización y áreas de aislamiento)',
      g.regPac, z.regPac, nRegPac, pp.regPac
    );
    addZonaBlock(
      'Drenajes de piso en áreas clínicas (pasillos, UCI, quirófanos, recuperación)',
      g.drClin, z.drClin, nDrClin, pp.drClin
    );
    addZonaBlock(
      'Baños y vestidores de staff (médicos, enfermería, personal de apoyo)',
      g.banosStaff, z.banosStaff, nBanosStaff, pp.banosStaff
    );
    addZonaBlock(
      'Regaderas de personal (vestidores de médicos y enfermería)',
      g.regStaff, z.regStaff, nRegStaff, pp.regStaff
    );
    addZonaBlock(
      'Registros principales antes de fosa o descarga',
      g.regPpal, z.regPpal, nRegPpal, pp.regPpal
    );
    addZonaBlock(
      'Anatomía patológica y morgue (drenajes donde se descargan fluidos ya tratados)',
      g.morgue, z.morgue, nMorgue, pp.morgue
    );

    // Servicios opcionales
    addZonaBlock(
      'Drenajes en cocina hospitalaria',
      g.drCocina, z.drCocina, nDrCocina, pp.drCocina
    );
    addZonaBlock(
      'Trampas de grasa (cocina, cafetería, snack)',
      g.trampas, z.trampas, nTrampas, pp.trampas
    );
    addZonaBlock(
      'Drenajes en comedor / cafetería',
      g.drComedor, z.drComedor, nDrComedor, pp.drComedor
    );

    addZonaBlock(
      'Lavandería hospitalaria &ndash; drenajes de lavadoras',
      g.drLavadoras, z.drLavadoras, nDrLavadoras, pp.drLavadoras
    );
    addZonaBlock(
      'Lavandería hospitalaria &ndash; drenajes de piso',
      g.drLavPiso, z.drLavPiso, nDrLavPiso, pp.drLavPiso
    );

    addZonaBlock(
      'Laboratorio clínico',
      g.drLabClin, z.drLabClin, nDrLabClin, pp.drLabClin
    );
    addZonaBlock(
      'Banco de sangre',
      g.drBanco, z.drBanco, nDrBanco, pp.drBanco
    );
    addZonaBlock(
      'Laboratorio de microbiología / virología',
      g.drLabMicro, z.drLabMicro, nDrLabMicro, pp.drLabMicro
    );
    addZonaBlock(
      'Anatomía patológica / histopatología (drenajes adicionales)',
      g.drAnat, z.drAnat, nDrAnat, pp.drAnat
    );

    addZonaBlock(
      'Unidades de hemodiálisis',
      g.drHemo, z.drHemo, nDrHemo, pp.drHemo
    );
    addZonaBlock(
      'Salas de quimioterapia / infusión',
      g.drQuimio, z.drQuimio, nDrQuimio, pp.drQuimio
    );

    addZonaBlock(
      'Cuartos de residuos ordinarios y compactadoras',
      g.drResOrd, z.drResOrd, nDrResOrd, pp.drResOrd
    );
    addZonaBlock(
      'Cuartos de RPBI con descarga a drenaje sanitario',
      g.drResRpbi, z.drResRpbi, nDrResRpbi, pp.drResRpbi
    );

    addZonaBlock(
      'Registros hacia fosa general o PTAR',
      g.regPtar, z.regPtar, nRegPtar, pp.regPtar
    );

    // Nota general de aplicación
    html +=
      '<div style="margin-top:10px;color:#444;font-size:14px;">' +
      'Aplica preferentemente al final del turno o en horarios de menor uso (noche / madrugada), ' +
      'cuando hay menos arrastre de agua de limpieza y menos químicos en las líneas. Evita usar cloro, ' +
      'sosa cáustica o desengrasantes muy agresivos al menos <strong>6–12 horas antes y después</strong> ' +
      'de aplicar BACTER spp., para no afectar la actividad biológica. En drenajes con presencia de sangre, ' +
      'orina y medicamentos, asegúrate de seguir siempre los protocolos de neutralización y manejo de RPBI; ' +
      'BACTER spp. se aplica sobre líneas ya compatibles con descarga a drenaje sanitario.' +
      '</div>';

    // Bloque DBO / DQO referencial
    html +=
      '<div style="margin-top:14px;font-size:14px;color:#0b3d91;">' +
      '<strong>Comportamiento esperado en DBO / DQO (dato referencial)</strong><br>';

    if (dbo > 0 || dqo > 0) {
      var dboObjetivo = dbo > 0 ? Math.round(dbo * 0.5) : null;
      var dqoObjetivo = dqo > 0 ? Math.round(dqo * 0.5) : null;

      html += 'Si actualmente tienes valores cercanos a ';

      if (dbo > 0) {
        html += 'DBO ≈ <strong>' + Math.round(dbo) + ' mg/L</strong>';
      }
      if (dbo > 0 && dqo > 0) {
        html += ' y ';
      }
      if (dqo > 0) {
        html += 'DQO ≈ <strong>' + Math.round(dqo) + ' mg/L</strong>';
      }

      html +=
        ', aplicando BACTER spp. de forma continua según este programa ' +
        'y manteniendo buenas prácticas de higiene en habitaciones, cocinas, lavandería y servicios clínicos, ' +
        'es razonable esperar reducciones importantes en <strong>2 a 3 meses</strong>, acercándote a valores alrededor de ';

      if (dboObjetivo) {
        html += 'DBO ≈ <strong>' + dboObjetivo + ' mg/L</strong>';
      }
      if (dboObjetivo && dqoObjetivo) {
        html += ' y ';
      }
      if (dqoObjetivo) {
        html += 'DQO ≈ <strong>' + dqoObjetivo + ' mg/L</strong>';
      }

      html += '. ';
    } else {
      html +=
        'En hospitales y clínicas donde se dosifica de forma constante bajo un programa <strong>' +
        labelPrograma +
        '</strong>, suele observarse una disminución progresiva de DBO y DQO en un periodo de ' +
        '<strong>1 a 3 meses</strong>, siempre que se mantengan buenas prácticas de operación y se controlen ' +
        'los vertidos de químicos agresivos.';
    }

    html +=
      ' Este cálculo es <strong>solo orientativo</strong>. El cumplimiento con la NOM aplicable ' +
      'y con tu autoridad ambiental o sanitaria siempre debe verificarse mediante muestreos de laboratorio ' +
      'y la interpretación de tu responsable sanitario o asesor ambiental.' +
      '</div>';

    resDiv.innerHTML = html;
    resDiv.style.display = 'block';
  }



  // -------------------------
  //  INICIALIZACIÓN
  // -------------------------

  function init() {
    var widgets = qsa('.bacter-widget[data-scenario="hospitales_salud"]');
    if (!widgets.length) return;

    widgets.forEach(function (elWidget) {
      try {
        var cfg = {
          scenario: elWidget.getAttribute('data-scenario') || 'hospitales_salud',
          title: elWidget.getAttribute('data-title') || null,
          defaults: {
            segmento_salud:
              elWidget.getAttribute('data-default-segmento') || 'pequeno',
            tipo_centro_salud:
              elWidget.getAttribute('data-default-tipo-centro') || 'clinica_pequena',
            programa:
              elWidget.getAttribute('data-default-programa') || 'semanal',

            num_camas: parseInt(
              elWidget.getAttribute('data-default-num-camas') || BASE_CAMAS,
              10
            ),
            ocupacion_pct: parseFloat(
              elWidget.getAttribute('data-default-ocupacion-porcentaje') ||
                BASE_OCUPACION_PCT
            ),
            pacientes_ambulatorios_dia: parseFloat(
              elWidget.getAttribute('data-default-pacientes-ambulatorios-dia') ||
                BASE_AMBULATORIOS_DIA
            ),

            caudal_litros_dia: parseFloat(
              elWidget.getAttribute('data-default-caudal') ||
                BASE_CAUDAL_L_DIA
            ),
            dbo_inicial: parseFloat(
              elWidget.getAttribute('data-default-dbo') || BASE_DBO
            ),
            dqo_inicial: parseFloat(
              elWidget.getAttribute('data-default-dqo') || BASE_DQO
            ),

            banos_pacientes: parseInt(
              elWidget.getAttribute('data-default-banos-pacientes') || 0,
              10
            ),
            regaderas_pacientes: parseInt(
              elWidget.getAttribute('data-default-regaderas-pacientes') || 0,
              10
            ),
            drenajes_clinicos: parseInt(
              elWidget.getAttribute('data-default-drenajes-clinicos') || 0,
              10
            ),
            banos_staff: parseInt(
              elWidget.getAttribute('data-default-banos-staff') || 0,
              10
            ),
            regaderas_staff: parseInt(
              elWidget.getAttribute('data-default-regaderas-staff') || 0,
              10
            ),
            registros_principales: parseInt(
              elWidget.getAttribute('data-default-registros-principales') || 0,
              10
            ),
            drenajes_morgue: parseInt(
              elWidget.getAttribute('data-default-drenajes-morgue') || 0,
              10
            ),

            drenajes_cocina: parseInt(
              elWidget.getAttribute('data-default-drenajes-cocina') || 0,
              10
            ),
            trampas_grasa: parseInt(
              elWidget.getAttribute('data-default-trampas-grasa') || 0,
              10
            ),
            drenajes_comedor: parseInt(
              elWidget.getAttribute('data-default-drenajes-comedor') || 0,
              10
            ),

            drenajes_lavadoras: parseInt(
              elWidget.getAttribute('data-default-drenajes-lavadoras') || 0,
              10
            ),
            drenajes_piso_lavanderia: parseInt(
              elWidget.getAttribute('data-default-drenajes-piso-lavanderia') || 0,
              10
            ),

            drenajes_lab_clinico: parseInt(
              elWidget.getAttribute('data-default-drenajes-lab-clinico') || 0,
              10
            ),
            drenajes_banco_sangre: parseInt(
              elWidget.getAttribute('data-default-drenajes-banco-sangre') || 0,
              10
            ),
            drenajes_lab_micro: parseInt(
              elWidget.getAttribute('data-default-drenajes-lab-micro') || 0,
              10
            ),
            drenajes_anatomia: parseInt(
              elWidget.getAttribute('data-default-drenajes-anatomia') || 0,
              10
            ),

            drenajes_hemodialisis: parseInt(
              elWidget.getAttribute('data-default-drenajes-hemodialisis') || 0,
              10
            ),
            drenajes_quimio: parseInt(
              elWidget.getAttribute('data-default-drenajes-quimio') || 0,
              10
            ),

            drenajes_residuos_ordinarios: parseInt(
              elWidget.getAttribute('data-default-drenajes-residuos-ordinarios') || 0,
              10
            ),
            drenajes_residuos_rpbi: parseInt(
              elWidget.getAttribute('data-default-drenajes-residuos-rpbi') || 0,
              10
            ),

            registros_hacia_ptar: parseInt(
              elWidget.getAttribute('data-default-registros-hacia-ptar') || 0,
              10
            ),

            tiene_ptar:
              elWidget.getAttribute('data-default-tiene-ptar') === 'true',
            caudal_ptar_m3_dia: parseFloat(
              elWidget.getAttribute('data-default-caudal-ptar-m3-dia') || 0
            ),

            servicio_cocina:
              elWidget.getAttribute('data-default-servicio-cocina') === 'true',
            servicio_lavanderia:
              elWidget.getAttribute('data-default-servicio-lavanderia') === 'true',
            servicio_laboratorios:
              elWidget.getAttribute('data-default-servicio-laboratorios') === 'true',
            servicio_hemodialisis:
              elWidget.getAttribute('data-default-servicio-hemodialisis') === 'true',
            servicio_residuos:
              elWidget.getAttribute('data-default-servicio-residuos') === 'true',

            carga: elWidget.getAttribute('data-default-carga') || 'baja',
            modo: elWidget.getAttribute('data-default-modo') || 'mantenimiento',
            quimicos:
              elWidget.getAttribute('data-default-quimicos') === 'true'
          }
        };

        renderWidget(elWidget, cfg);
      } catch (err) {
        console.error('bacter-hospitales init error', err);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
